import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import StoryForm from './components/StoryForm';

export default function SubmitStoryPage() {
  const [scrolled, setScrolled] = useState(false);
  const [searchParams] = useSearchParams();
  const isEditing = !!searchParams.get('edit');

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex flex-col">
      <Navbar />

      <main className="flex-1 pt-24 pb-16">
        {/* Page Header */}
        <div className="relative overflow-hidden border-b border-red-900/20 mb-10">
          <div
            className="absolute inset-0 opacity-10"
            style={{
              backgroundImage: `url('https://public.readdy.ai/ai/img_res/2b39ff0aa7d067114d03ba870034c15c.jpg')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] via-[#0a0a0a]/80 to-[#0a0a0a]" />
          <div className="relative max-w-4xl mx-auto px-6 py-12">
            {/* Breadcrumb */}
            <nav className="flex items-center gap-2 text-xs text-zinc-500 mb-6">
              <Link to="/" className="hover:text-red-400 transition-colors cursor-pointer">Home</Link>
              <i className="ri-arrow-right-s-line"></i>
              <Link to="/profile/writer" className="hover:text-red-400 transition-colors cursor-pointer">My Profile</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-zinc-300">{isEditing ? 'Edit Story' : 'Submit Story'}</span>
            </nav>

            <div className="flex items-center gap-4 mb-3">
              <div className="w-10 h-10 flex items-center justify-center bg-red-900/30 border border-red-800/50 rounded-lg">
                <i className={`${isEditing ? 'ri-edit-line' : 'ri-quill-pen-line'} text-red-500 text-xl`}></i>
              </div>
              <h1 className="text-3xl font-bold text-white" style={{ fontFamily: 'Cinzel, serif' }}>
                {isEditing ? 'Edit Your Story' : 'Submit Your Story'}
              </h1>
            </div>
            <p className="text-zinc-400 text-base ml-14" style={{ fontFamily: 'Crimson Text, serif' }}>
              {isEditing
                ? 'Update your story details, content, or cover image and republish.'
                : 'Share your darkest tales with the Sinister Files community. Publish instantly or save as a draft.'}
            </p>
          </div>
        </div>

        {/* Form Area */}
        <div className="max-w-4xl mx-auto px-6">
          {/* Writing Tips — only show for new submissions */}
          {!isEditing && (
            <div className="bg-zinc-900/60 border border-red-900/20 rounded-lg p-5 mb-8 flex flex-wrap gap-6">
              <div className="flex items-start gap-3 flex-1 min-w-[200px]">
                <div className="w-8 h-8 flex items-center justify-center text-red-500 shrink-0 mt-0.5">
                  <i className="ri-lightbulb-line text-lg"></i>
                </div>
                <div>
                  <p className="text-zinc-200 text-sm font-semibold mb-1" style={{ fontFamily: 'Cinzel, serif' }}>Hook Early</p>
                  <p className="text-zinc-500 text-xs leading-relaxed" style={{ fontFamily: 'Crimson Text, serif' }}>
                    Grab readers in the first paragraph. Set the dread before the reveal.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 flex-1 min-w-[200px]">
                <div className="w-8 h-8 flex items-center justify-center text-red-500 shrink-0 mt-0.5">
                  <i className="ri-eye-line text-lg"></i>
                </div>
                <div>
                  <p className="text-zinc-200 text-sm font-semibold mb-1" style={{ fontFamily: 'Cinzel, serif' }}>Show, Don&apos;t Tell</p>
                  <p className="text-zinc-500 text-xs leading-relaxed" style={{ fontFamily: 'Crimson Text, serif' }}>
                    Use vivid sensory details to immerse readers in your world of darkness.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 flex-1 min-w-[200px]">
                <div className="w-8 h-8 flex items-center justify-center text-red-500 shrink-0 mt-0.5">
                  <i className="ri-shield-check-line text-lg"></i>
                </div>
                <div>
                  <p className="text-zinc-200 text-sm font-semibold mb-1" style={{ fontFamily: 'Cinzel, serif' }}>Follow Guidelines</p>
                  <p className="text-zinc-500 text-xs leading-relaxed" style={{ fontFamily: 'Crimson Text, serif' }}>
                    Review our <Link to="/guidelines" className="text-red-400 hover:underline cursor-pointer">writing guidelines</Link> before submitting.
                  </p>
                </div>
              </div>
            </div>
          )}

          <StoryForm />
        </div>
      </main>

      <Footer />
    </div>
  );
}
